<template>
    <div id="divPayment">
        <!-- List of Payment Options -->
        <div id="divPaymentTypes" class="col-lg-8 col-md-8" v-show="customerPaymentTypes.length > 1">
            <h5><b>{{ $t("message.selectPaymentOption") }}</b></h5>
            <br />
            <div class="list-group">
                <a :href="formatLink(paymentType.CustRedirectLink, paymentType.ProcessorId)" v-for="paymentType in customerPaymentTypes" :key="paymentType.ProcessorId" :target="paymentType.LinkTarget"
                            class="list-group-item list-group-item-action flex-column align-items-start text-center margin-bottom-15">
                    <div class="div-inline-block payment-type-img">
                        <img :src="formatImagePath(paymentType.ImagePath)" :alt="paymentType.Name" />
                    </div>
                    <div class="div-inline-block payment-type-desc text-center">
                        <h5 class="mb-1"><strong>{{ paymentType.Description }}</strong></h5>
                    </div>
                </a>
            </div>
        </div>
        <!-- Display no payment types available -->
        <div v-show="showNoDataAvailableMsg">
            <p class="alert alert-text">{{ $t("message.noPaymentTypesAvailable") }}</p>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'Payment',
    data() {
        return {
            customerPaymentTypes: '',
            showNoDataAvailableMsg: false
        }
    },
    mounted() {
        this.getAllCustomerPaymentTypes();        
    },
    methods: {
        getAllCustomerPaymentTypes() {
            // Get all Customer Payment Types
            // If we get only one Payment Type back, instead of displaying it we will go ahead and redirect to its appropriate page
            axios({
                method: "GET",
                url: this.$httpAxiosBaseUrl() + "Payment/GetAllCustomerPaymentProcessors?date=" + new Date().getTime()
            }).then(result => {
                var response = result.data;
                this.customerPaymentTypes = response;

                // If we only have one payment option setup in this case directly take the user to that link
                if (response !== '' && response.length === 1) {
                    var paymentOption = response[0];

                    if (paymentOption.ProcessorId === this.$SyscfgPaymentProcessors.Checkout) {
                        window.location = paymentOption.CustRedirectLink;
                    } else if (paymentOption.ProcessorId === this.$SyscfgPaymentProcessors.PayGoProcessing) {
                        this.$router.push({ name: 'Payment Processing' });
                    } else {
                        showError('Redirect URL has not been configured for this option.');
                    }
                } else if (response.length === 0) {
                    this.showNoDataAvailableMsg = true;
                }
            }, error => {
                console.log(error);
                this.$router.push({ name: 'Error' });
            });            
        },
        formatLink(custRedirectLink, processorId) {
            return processorId === this.$SyscfgPaymentProcessors.PayGoProcessing ? this.$formatOldCustomerPortalLinks(this.$httpAxiosBaseUrl(), custRedirectLink) : custRedirectLink;
        },
        showError(message) {
            this.$toasted.global.error(message);
            this.$announcer.set(message);
        },
        formatImagePath(imageUrl) {
            return this.$httpAxiosBaseUrl() + imageUrl;
        }
    }
}
</script>

<style scoped>
.payment-type-img {
    width: 25%;
}

    .payment-type-img img {
        min-width: 145px;
        width: 100%;
    }

.payment-type-desc {
    width: 70%;
}

.list-group-item:first-child {
    border-radius: 0;
}

@media only screen and (max-width : 600px) {
    .payment-type-img {
        width: auto;
    }
}
</style>